import { NgModule } from '@angular/core';
import { AbwDatatableComponent } from './abw-datatable.component';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { CommonModule } from '@angular/common';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatPaginatorModule } from '@angular/material/paginator';

@NgModule({
    declarations: [AbwDatatableComponent],
    imports: [
        CommonModule,
        NgxDatatableModule,
        MatSlideToggleModule,
        MatPaginatorModule,
    ],
    exports: [AbwDatatableComponent]
})
export class AbwDatatableModule {}